module.exports = "synthrone-dialog-layout {\n  overflow: hidden; }\n\n.dialog-content {\n  padding: 20px; }\n\n.dialog-content .mat-form-field {\n    display: block; }\n\n.dialog-content .fileNameContainer {\n    display: inline-block;\n    margin: 0 5px; }\n\n.loading-form {\n  text-align: center;\n  height: 50px; }\n\n.loading-form .loading-spinner {\n    height: 50px;\n    display: inline-block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/forms/add-update-font-variant/add-update-font-variant.component.scss
// module id = ./src/app/components/forms/add-update-font-variant/add-update-font-variant.component.scss
// module chunks = main